import { Injectable } from '@angular/core';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { CustomCart } from '../../../cart/models/custom-cart.model';
import { CartsByLegalEntity } from '../../../../SGRE-shared/models/cartsByLegalEntity.model';
import { CartService } from '../../../cart/services/cart.service';

@Injectable()
export class OrderDetailsEffectsService {

    constructor(
        private storageService: StorageService,
        private cartsService: CartService,
    ) { }

    recreateCartSideEffects(apiResponse: CustomCart): CartsByLegalEntity {
        this.cartsService.clearCartState();
        this.storageService.activeCart = apiResponse || {};
        this.storageService.cartId = apiResponse?.code || '';
        return {
            carts: [apiResponse]
        } as CartsByLegalEntity;
    }
}